import { Person } from './person.model';
import { DateString, DateTimeString } from './date.model';
import { Fund } from './fund.model';
import { IdentifiableBase } from './identifiable-base.model';
import { Employer } from './employer.model';
import { Lead } from './lead.model';

export interface PersonFundRequestStatus {
  person: Person;
  fund: Fund;
  lead: Lead | undefined;
  onboardingRequest: OnboardingRequest;
  identificationUrl: string;
}

export enum OnboardingRequestStatus {
  NEW = 'NEW',
  NEW_IDENTIFICATION_SESSION = 'NEW_IDENTIFICATION_SESSION',
  WAITING_FOR_IDENTITY = 'WAITING_FOR_IDENTITY',
  IDENTITY_CHECKED = 'IDENTITY_CHECKED',
  IDENTITY_CHECKED_PROCESSED = 'IDENTITY_CHECKED_PROCESSED',
  IDENTITY_CHECKED_ERROR = 'IDENTITY_CHECKED_ERROR',
  SUBMITTED = 'SUBMITTED',
  SUBMITTED_SIGNED = 'SUBMITTED_SIGNED',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
}

export interface OnboardingRequest extends IdentifiableBase {
  documentKey: string;
  status: OnboardingRequestStatus;
  submittedAt: DateTimeString;
  contributionAmount: number;
  firstPaymentDate: DateString;
  monthlyDueDate: number;
  employerInfo: Employer;
  employerContributionAmount: number;
}
